export default __webpack_public_path__ + "slices/main/assets/public/fonts/inter/inter-bold.3c747ac4004be3a30e9807662caebaa0.woff2";